import { Collapse, type CollapseProps } from '@faceup/ui-base'

type CollapseItems = CollapseProps['items']

const items: CollapseItems = [
  {
    key: '1',
    label: 'Co se bude dít dál?',
    children: (
      <>
        Pokud vše půjde, jak má, mělo by se tvé upozornění dostat k takové osobě na tvé škole, která
        má s řešením šikany a podobných problémů zkušenosti. Ta to nenechá být a zkusí udělat
        maximum proto, aby pomohla. Pokud by se nic nedělo, můžeš jí skrz FaceUp napsat ještě
        jednou, nebo na škole vyhledat vašeho metodika prevence, případně školního psychologa a o
        problémech jim říct osobně.
      </>
    ),
  },
  {
    key: '2',
    label: 'Chceš si o problému popovídat?',
    children: (
      <>
        Pokud si budeš chtít o problému promluvit, obrať se na{' '}
        <a href='https://www.linkabezpeci.cz/' target='_blank' rel='noopener noreferrer'>
          Linku bezpečí
        </a>
        . V případě život ohrožující situace zavolejte linku 112.
      </>
    ),
  },
]

export const SchoolSentCollapse = () => {
  return <Collapse accordion ghost items={items} />
}
